export const TEST_ACTION = "TEST_ACTION"
export const SET_TEST_ACTION = "SET_TEST_ACTION"

export const GET_REFRESH_TOKEN = 'GET_REFRESH_TOKEN'
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN'
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR'
export const LOG_OUT_USER = 'LOG_OUT_USER'
export const SET_LOG_OUT_USER = 'SET_LOG_OUT_USER'
export const GET_UNITS = "GET_UNITS"
export const SET_UNITS = "SET_UNITS"

export const GET_CONTENT = "GET_CONTENT"
export const SET_CONTENT = "SET_CONTENT"


export const GET_ALL_CONTENT = "GET_ALL_CONTENT"
export const SET_ALL_CONTENT = "SET_ALL_CONTENT"

export const GET_NEW_SECTION = "GET_NEW_SECTION"
export const SET_NEW_SECTION = "SET_NEW_SECTION"

export const GET_RESET_UPDATE_REDUCER = "GET_RESET_UPDATE_REDUCER"
export const SET_RESET_UPDATE_REDUCER = "SET_RESET_UPDATE_REDUCER"